// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3rRny","header":"MergedInvoice_header__38lKP"};